import { BASE_URL } from "../environment/environment";
import axios from "axios";

const buildUrl = (endpoint, databaseId) => {
  const url = new URL(`${BASE_URL}/${endpoint}`);
  if (databaseId) {
    url.searchParams.append('databaseId', databaseId);
  }
  return url.toString();
};

export const fetchData = async (endpoint, databaseId) => {
  try {
    const url = buildUrl(endpoint, databaseId);
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`Błąd podczas pobierania danych: ${response.statusText}`);
    }
    return await response.json();
  } catch (error) {
    console.error(`Wystąpił błąd: ${error.message}`);
    throw error;
  }
};

export const getChangeLogs = async (databaseId) => {
  return fetchData("PamInfo/GetChangelogs", databaseId || undefined);
};

export const getConceptsList = async (databaseId) => {
  return fetchData("PamInfo/GetIdeas", databaseId || undefined);
};

export const getCurrentFeatures = async (databaseId) => {
  return fetchData("PamInfo/GetFeatures", databaseId || undefined);
};

const apiRequest = async (method, endpoint, data = {}, params = {}) => {
  try {
    const response = await axios({
      method,
      url: `${BASE_URL}/${endpoint}`,
      data,
      params,
      headers: { 'Content-Type': 'application/json' },
    });
    return response;
  } catch (error) {
    throw error.response?.data || "Wystąpił błąd";
  }
};

export const checkEmailAvailability = async (email) => {
  try {
    const response = await axios.get(`/api/Auth/check-username?email=${encodeURIComponent(email)}`);
    return response;  
  } catch (error) {
    console.error(error);
    throw error;  
  }
};

export const login = async (email, password) => {
  return apiRequest('POST', 'Auth/login', { email, password });
};

export const register = async (email, password, name, lastName, phoneNumber, companyPosition) => {
  return apiRequest('POST', 'Auth/register', { email, password, name, lastName, phoneNumber, companyPosition });
};

export const forgotPassword = async (email) => {
  return apiRequest('POST', 'Auth/forgot-password', { email });
};

export const resetPassword = async (email, token, newPassword) => {
  return apiRequest('POST', 'Auth/reset-password', { email, token, newPassword });
};